import { createContext } from "react";

import {
  AppConfiguration,
  GenerationMode,
  Globals,
  ParentUrlCallback,
} from "./types";

export const appSettingsStorage: {
  serviceBaseUrl: string;
  baseOrigin: string;
} = {
  serviceBaseUrl: "",
  baseOrigin: "",
};

export const ConfigContext = createContext<AppConfiguration | null>(null);

export const defaultParentWindowSize = {
  innerWidth: 500,
  innerHeight: 700,
};

export const GlobalsContext = createContext<Globals | null>(null);

export const generationModes: Record<
  NonNullable<GenerationMode>,
  GenerationMode
> = {
  submitting: "submitting",
  generating: "generating",
};

export const parentUrlsCallbacks: ParentUrlCallback[] = [];

export const defaultBotDataTrainedStatus = {
  is_bot_data_trained: true,
  are_sitemaps_trained: true,
  are_faq_trained: true,
};

export const imageMimetypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
];
export const allowedFileExtensions = ["pdf", "png", "jpg", "jpeg"];
export const defaultFileMaxSize = 5 * 1_024 * 1_024; // 5MB
export const defaultMaxFiles = 5;
export const presignedUrlValidityHours = 3;
